"use client"
import { ComponentConfig } from "@measured/puck"
import CKEditorWrapper from "../../../../../../lib/config/lib/CkeditorWrapper"
import { commonStylesProps } from "../../lib/commonCSSProps"
import { RenderConfig, TextProps } from "./RenderConfig"

export const Text: ComponentConfig<TextProps> = {
  // @ts-ignore
  fields: {
    text: {
      label: "Text",
      type: "custom",
      render: ({ value, onChange }) => {
        return <CKEditorWrapper value={value} onChange={onChange} />
      },
    },
    ...commonStylesProps,
  },
  defaultProps: {
    text: "Default text",
    className: "",
    styles: {
      mobile: { display: "block" },
      tablet: { display: "block" },
      desktop: { display: "block" },
    },
  },
  ...RenderConfig,
}
